export default __webpack_public_path__ + "static/images/service.89407ba3.png";